import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch6_p10 } from "../../../layouts/ch6_p10/ch6_p10";

export class Chapter6Page10 extends AbstractStoryState implements ReturnType<typeof ch6_p10> {

    readonly bg = this.addChild(new SceneSprite());
    readonly texture = [this.addChild(new SceneSprite()), this.addChild(new SceneSprite())];
    readonly cupcakeRight = this.addChild(new SceneSprite());
    readonly cupcakeLeft = this.addChild(new SceneSprite());
    readonly cupcakeLeftCut = this.addChild(new SceneSprite());

    readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch6_p10/"));
    readonly frameRight = this.addChild(SceneSprite.withPrefix("ch6_p10/"));

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch6_p10.call(this);
        this.frameLeft.visible = false;
        this.frameRight.visible = false;

        this.cupcakeLeftCut.visible = false;

        this._subscriptions.push(PubSub.subscribeOnce('swipe', this.onSwipe.bind(this))); // mobile

        this.cupcakeLeft.interactive = true;
        this.cupcakeLeft.buttonMode = true;
        this.cupcakeLeft.accessible = true;
        this.cupcakeLeft.addListener(HLF.Input.Events.CLICK, this.onSwipe.bind(this)); // desktop

        // super.init calls onResize
        super.init(pSize, pData);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);
    }

    public animateOut(pOnComplete: () => void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        super.onAnimateInComplete();
    }

    protected onSwipe(pTopic: 'swipe', pData: {x: number, y: number}) {
        console.log(pTopic, pData);
        this.cupcakeLeft.visible = false;
        this.cupcakeLeftCut.visible = true;
        TweenLite.to(this.cupcakeLeftCut, 1.5, {pixi: {x: this.cupcakeLeftCut.x - 50}});
        TweenLite.to(this.cupcakeRight, 1.5, {pixi: {x: this.cupcakeRight.x + 50}});
        TweenLite.delayedCall(2.5, ()=>{
            this.gotoNextState({transition: 'left'});
        });
    }
}